import React, { useState } from 'react';
import PageTopButton from '@components/common/pageTopButton';
import EventProfileFill, { ModalState } from './modal';
import Intro from './intro';
import FloatingBar from './floatingBar';
import Banner1 from './banner1';
import Banner2 from './banner2';
import Profile from './profile';
import ProfileDownload from './profileDownload';
import classnames from 'classnames/bind';

import styles from './commonStyle.module.scss';
const cx = classnames.bind(styles);

const EventMailProfile = () => {
  const [modalState, setModalState] = useState<ModalState>(null);
  const openModal = (type: ModalState) => setModalState(type);

  return (
    <div className={cx('wrap')}>
      <>
        <Intro />
        <Profile />
        <ProfileDownload openModal={openModal} />
        <Banner1 />
        <Banner2 />
        <div className={cx('banner3')} />
      </>

      <FloatingBar />
      <EventProfileFill modalState={modalState} setModalState={setModalState} />

      <PageTopButton />
    </div>
  );
};

export default EventMailProfile;
